export default {
  select2: {
    defaultItemComponent: "iconItem",
  },
};
